import React, { useRef } from 'react';
import { Hidden, makeStyles, IconButton } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import config from '@/configs/config';
import { PAGING_BUTTON_ACTION_MAP } from '../../preorder/containers/PreOrderPage/components/List/Slider';

const useTileStyle = makeStyles(() => ({
  root: {
    width: '100%',
    paddingTop: '122.22%',
    position: 'relative',
  },
  image: {
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  },
}));

function Tile({ imageUrl }) {
  const classes = useTileStyle();

  return (
    <div className={classes.root}>
      <img
        src={`${config.RESOURCE_URI}${imageUrl}`}
        alt=""
        className={classes.image}
      />
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'stretch',
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2, 1),
    width: '100%',
  },
  tile: {
    flexShrink: 0,
    padding: theme.spacing(0, 1),
  },
  header: {
    display: 'flex',
    fontSize: 16,
    fontWeight: 'bold',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1),
    textAlign: 'left',
  },
  itemsContainer: {
    display: 'flex',
    marginTop: theme.spacing(1),
    overflowX: 'auto',
    width: '100%',
    '&::-webkit-scrollbar': { display: 'none' },

    '& > *': {
      flexBasis: '45%',

      [theme.breakpoints.up('sm')]: {
        flexBasis: '31%',
      },

      [theme.breakpoints.up('md')]: {
        flexBasis: '19%',
      },
    },
  },
  navigatorContainer: {
    alignItems: 'center',
    display: 'none',
    marginLeft: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
}));

export default function Banner({ images, title }) {
  const classes = useStyle();
  const containerRef = useRef(null);

  const pagingButtonClick = (type) => {
    const { scrollLeft, offsetWidth } = containerRef.current;

    containerRef.current.scrollTo({
      behavior: 'smooth',
      left: type === PAGING_BUTTON_ACTION_MAP.BACK
        ? scrollLeft - offsetWidth
        : scrollLeft + offsetWidth,
    });
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.title}>{title || ''}</div>
        <Hidden xsDown>
          <div className={classes.navigatorContainer}>
            <IconButton
              style={{ backgroundColor: '#f5f5f5', width: 24, height: 24 }}
              onClick={() => pagingButtonClick(PAGING_BUTTON_ACTION_MAP.BACK)}
            >
              <ArrowBackIcon style={{ fontSize: 16 }} />
            </IconButton>
            <IconButton
              style={{
                marginLeft: 16,
                backgroundColor: '#f5f5f5',
                width: 24,
                height: 24,
              }}
              onClick={() => pagingButtonClick(PAGING_BUTTON_ACTION_MAP.FORWARD)}
            >
              <ArrowForwardIcon style={{ fontSize: 16 }} />
            </IconButton>
          </div>
        </Hidden>
      </div>
      <div className={classes.itemsContainer} ref={containerRef}>
        {
          images.map((url) => (
            <div className={classes.tile} key={url}>
              <Tile imageUrl={url} />
            </div>
          ))
        }
      </div>
    </div>
  );
}
